<template>
    <OverlayLoader :isLoading="!isLoaded">
        <main class="page page-dashboard">
            <div class="container">

                <PageHeader
                    :title="$translate.text('general.profile.combine')"
                />

                <Alert :show="true">{{ t('client.feeds.combine.message') }}</Alert>

                <form @submit.prevent="submitForm" method="POST">
                    <div class="row">
                        <div class="col-sm-3">
                            <h4>{{ t('client.feeds.combine.combine') }}</h4>
                        </div>
                        <div class="col-sm"></div>
                        <div class="col-sm">
                            <h4>{{ t('client.feeds.combine.draganddrop') }}</h4>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-8" style="display:flex; overflow: auto; height: 700px; padding: 0px;">
                            <div class="col-sm-4">
                                <div v-for="(item, index) in combines" :key="index" class="list-group-item list-group-item--header" :style="{'height': `${(37 * item.placeholders.length) + (10 * (item.placeholders.length-1))}px`}">
                                    {{ t(`client.feeds.combine.columns.${item.name}`) }}
                                    <span v-if="item.required">*</span>
                                    <i class="fal fa-plus pointer" v-if="item.name === 'image' && editMode === true" style="float:right;" @click="appendPlaceholder(index)"></i>
                                </div>
                            </div>
                            <div class="col-sm-8">
                                <template v-for="(item, itemIndex) in combines">
                                    <drop
                                        class="drop list-group-item list-group-item--drop no-select"
                                        v-for="(placeholder, placeholderIndex) in item.placeholders"
                                        :key="`labels-${itemIndex}-placeholders-${placeholderIndex}`"
                                        :class="{'list-group-item--targeted': placeholder.hovered, 'list-group-item--holder': placeholder.value === ''}"
                                        @drop="dropHandle($event, itemIndex, placeholderIndex)"
                                        @dragenter="dragEnter(itemIndex, placeholderIndex)"
                                        @dragleave="dragLeave(itemIndex, placeholderIndex)"
                                    >
                                        {{ placeholder.value }}
                                        <i class="fal fa-trash-alt pointer" v-if="placeholder.value !== '' && editMode === true" style="float:right;" @click="dropClear(itemIndex, placeholderIndex)"></i>
                                    </drop>
                                </template>
                            </div>
                        </div>
                        <div class="col-sm" style="overflow: auto;height: 700px;">
                            <drag
                                class="drag list-group-item list-group-item--drag no-select"
                                v-for="(item, index) in uncombinedValues"
                                :key="index"
                                :transfer-data="item.key"
                                :draggable="editMode === true"
                            >
                                <i class="fal fa-arrows"></i> {{ item.key }}
                                <i class="fal fa-eye" v-tooltip.top="$translate.text('general.example') + `: ` + item.example" :popoverInnerClass="`tooltip-inner-boxed`"></i>
                            </drag>
                        </div>
                    </div>

                    <div class="col-sm-12">
                        <FormSubmit
                            :routeAfterCancelLink="{ name: 'Resellers Profiles' }"
                            :buttonLabel="submittingIsLoading ? $translate.text('general.save.saving') :  $translate.text('general.save')"
                            :disabled="submittingIsLoading || editMode === false"
                        />
                    </div>

                </form>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';

import Alert from '@/components/Alert/Alert';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';

import PageHeader from '@/components/PageHeader/PageHeader';
import FormSubmit from '@/components/Forms/FormSubmit';
import handleError from '@/helpers/error';


export default {
    name: 'CombineProfile',

    components: {
        PageHeader,
        FormSubmit,
        OverlayLoader,
        Alert,
    },

    data() {
        return {
            combines: [
                {
                    name: 'name',
                    value: '',
                    required: true,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'unique_code',
                    value: '',
                    required: true,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'price',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'purchase_price',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'manufacturer',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'category',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'ean',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'height',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'width',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'length',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'weight',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'description',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'image',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'manufacturer_code',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'order_number',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'in_stock',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'amount_in_stock',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'tax_class_id',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
                {
                    name: 'variant',
                    value: '',
                    required: false,
                    hovered: false,
                    placeholders: [
                        { value: '', hovered: false },
                    ],
                },
            ],

            loaded: {
                values: false,
                combined: false,
            },

            values: [],

            submittingIsLoading: false,

            editMode: true,
        };
    },

    created() {
        this.getValues();
        this.getCombined();
    },

    methods: {

        dropHandle(data, itemIndex, placeholderIndex) {
            this.combines[itemIndex].placeholders[placeholderIndex].hovered = false;
            this.combines[itemIndex].placeholders[placeholderIndex].value = data;
        },

        dropClear(itemIndex, placeholderIndex) {
            this.combines[itemIndex].placeholders[placeholderIndex].value = '';
        },

        dragEnter(itemIndex, placeholderIndex) {
            this.combines[itemIndex].placeholders[placeholderIndex].hovered = true;
        },

        dragLeave(itemIndex, placeholderIndex) {
            this.combines[itemIndex].placeholders[placeholderIndex].hovered = false;
        },

        appendPlaceholder(index) {
            this.combines[index].placeholders.push({
                hovered: false,
                value: '',
            });
        },


        getValues() {
            const id = this.$route.params.id;
            this.API.resellers.profiles.combine.values(id)
                .then(response => {
                    this.values = response.data;
                    this.loaded.values = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombined() {
            const id = this.$route.params.id;
            this.API.resellers.profiles.combine.combined(id)
                .then(response => {
                    if (response.data.data) {
                        const data = response.data.data;
                        this.editMode = data.maatwerk === false;

                        Object.keys(data).forEach(index => {
                            const indexOf = this.combines.findIndex(i => i.name === index);
                            if (indexOf > -1) {
                                this.combines[indexOf].placeholders = [];

                                data[index].forEach(value => {
                                    this.combines[indexOf].placeholders.push({
                                        hovered: false,
                                        value: value !== null ? value : '',
                                    });
                                });
                            }
                        });
                    }

                    this.loaded.combined = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        submitForm() {
            const id = this.$route.params.id;
            const data = {};
            const errors = [];

            this.combines.forEach(item => {
                item.placeholders.forEach(placeholder => {
                    if (item.required && placeholder.value === '') {
                        errors.push(
                            `- ${this.$translate.text('client.feeds.combine.required').replace('%field%', this.$translate.text(`client.feeds.combine.columns.${item.name}`))}`,
                        );
                    } else if (placeholder.value !== '') {
                        if (data[item.name] === undefined) {
                            data[item.name] = [];
                        }

                        data[item.name].push(placeholder.value);
                    }
                });
            });

            if (!data.price && !data.purchase_price) {
                errors.push(
                    `- ${this.$translate.text('client.feeds.combine.required').replace('%field%', this.$translate.text('client.feeds.combine.columns.price-purchase'))}`,
                );
            }

            if (errors.length > 0) {
                swal({
                    title: this.$translate.text('alert.whoops'),
                    text: errors.join('\n'),
                });
            } else {
                this.API.resellers.profiles.combine.update(id, data)
                    .then(() => {
                        this.submittingIsLoading = false;
                        this.$router.push({ name: 'Resellers Profiles' });
                    })
                    .catch((error) => {
                        this.submittingIsLoading = false;
                        handleError({
                            error,
                            message: this.$translate.text('alert.whoops'),
                        });
                    });
            }
        },

    },

    computed: {
        isLoaded() {
            return this.loaded.values && this.loaded.combined;
        },

        uncombinedValues() {
            const combined = [];

            this.combines.forEach(item => {
                item.placeholders.forEach(placeholder => {
                    if (placeholder.value) {
                        if (placeholder.value.length > 0) {
                            combined.push(placeholder.value);
                        }
                    }
                });
            });

            return this.values.filter(value => !combined.includes(value.key));
        },
    },
};
</script>
<style lang="scss" scoped>
    .no-select {
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select:none;
        user-select:none;
        -o-user-select:none;
    }
</style>
